import React, { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  productSummarySelector,
  productModalErrorsSelector,
  productModalVisibleSelector,
  setProductModalVisibility,
} from "src/features/product-modal/productModalSlice";
import isEmpty from "src/shared/util/is-empty";
import getProductModalAttributes from "../util/get-product-modal-attributes";
import useAddToCart from "./useAddToCart";
import useProductDetail from "./useProductDetail";

const useProductModal = () => {
  const dispatch = useDispatch();
  const errors = useSelector(productModalErrorsSelector);
  const isVisible = useSelector(productModalVisibleSelector);
  const productSummary = useSelector(productSummarySelector);
  const { url } = productSummary ?? {};
  const shouldDisableBuying = !isEmpty(errors.waitForStreamStart);

  const {
    data: productDetail,
    isLoading: isDetailLoading,
    isFetching: isDetailFetching,
    toggleParams,
    resetParams,
  } = useProductDetail({
    url,
  });

  const {
    image,
    name,
    productDiscount,
    price,
    pk,
    enabledVariants,
    shouldShowModal,
  } = getProductModalAttributes(productDetail, productSummary, isVisible);

  const closeModal = useCallback(() => {
    dispatch(setProductModalVisibility(false));
  }, [dispatch]);

  const { onAddToCart, status } = useAddToCart(
    shouldDisableBuying,
    closeModal,
    productDetail,
    pk
  );

  useEffect(() => {
    if (!isVisible) {
      // reset url params
      resetParams();
    }
  }, [isVisible]);

  const product = {
    image,
    name,
    price: +price,
    pk,
    url,
    variants: productDetail?.variants,
    productDiscount,
    enabledVariants,
  };

  return {
    isDetailFetching: isDetailFetching,
    isLoading: isDetailLoading || status === "loading",
    isVisible: shouldShowModal,
    productDetail,
    status,
    product,
    toggleProductParams: toggleParams,
    onAddToCart,
  };
};

export default useProductModal;
